module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Hairline-3d311fd416dc98aed2d984858c60cf0c.woff";